<template>
  <div class="product-reviews">
    <div class="grid">
      <div class="col xs-span l9">
        <div id="ReviewsWidget" />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product reviews (product-reviews)
 * -----------------------------------------------------------------------------
 * Product reviews from Review.io.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'ProductReviews',

  props: {
    settings: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: () => ({}),
    },
  },

  data() {
    return {

    }
  },

  watch: {
    variant() {
      this.loadReviewsWidget()
    },
  },

  mounted() {
    this.loadReviewsWidget()
  },

  methods: {
    loadReviewsWidget() {
      const { ReviewsWidget } = window

      if (!this.variant || !ReviewsWidget || !this.settings) {
        return
      }

      const reviewsSettings = this.settings
      reviewsSettings.options.product_review.sku = this.variant.sku

      new ReviewsWidget('#ReviewsWidget', reviewsSettings)
    },
  },
}
</script>

<style lang="scss">
@import '../../../styles/components/reviews-io.scss';
@import './product-reviews';
</style>
